import { useDispatch, useSelector } from 'react-redux';

// Custom hooks for Redux (similar to how Recoil hooks work)
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// Helper hook that combines useSelector and useDispatch for convenience
export const useReduxState = (selector) => {
  const state = useSelector(selector);
  const dispatch = useDispatch();
  return [state, dispatch];
}; 